import { render, staticRenderFns } from "./addWorkPage.vue?vue&type=template&id=4d059e51&scoped=true&"
import script from "./addWorkPage.ts?vue&type=script&lang=js&"
export * from "./addWorkPage.ts?vue&type=script&lang=js&"
import style0 from "./addWorkPage.less?vue&type=style&index=0&id=4d059e51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d059e51",
  null
  
)

export default component.exports